// Generated file : do not modify
export enum AdminInfoCategorys
{
  NONE = 0,
  SYSTEM,
  METIER,
  RESSOURCE,
  CLIENT,
  TOUS
};

import { ObjTypes } from '@/generated/classes/ObjTypes';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Administration
export default class AdminInfo  {
  // table
  public table: string;
  // Type
  public objType: ObjTypes;
  // Objet
  public objName: string;
  // Catégorie
  public category: AdminInfoCategorys;
  // libellé
  public label: string;
  // 
  public count: number;
  // Notification INFO ou ACTION
  public notifDefType: NotifDefTypes;
  // Html version mobile
  public hasHtmlMobile: boolean;
  // Aide html
  public helpHtmlId: number;
  // Publi context
  public publiContext: string;

  constructor() {
    this.table = '';
    this.objType = ObjTypes.NONE;
    this.objName = '';
    this.category = AdminInfoCategorys.NONE;
    this.label = '';
    this.count = 0;
    this.notifDefType = NotifDefTypes.NONE;
    this.hasHtmlMobile = false;
    this.helpHtmlId = 0;
    this.publiContext = '';
  }

  public static fromJson (obj: AdminInfo): AdminInfo {
    const newAdminInfo: AdminInfo = new AdminInfo();
    newAdminInfo.table = obj.table;
    newAdminInfo.objType = obj.objType;
    newAdminInfo.objName = obj.objName;
    newAdminInfo.category = obj.category;
    newAdminInfo.label = obj.label;
    newAdminInfo.count = obj.count;
    newAdminInfo.notifDefType = obj.notifDefType;
    newAdminInfo.hasHtmlMobile = obj.hasHtmlMobile;
    newAdminInfo.helpHtmlId = obj.helpHtmlId;
    newAdminInfo.publiContext = obj.publiContext;
    return newAdminInfo;
  }

  public toJsonAdminInfo (): string {
    const json = {
      table: this.table,
      objType: this.objType,
      objName: this.objName,
      category: this.category,
      label: this.label,
      count: this.count,
      notifDefType: this.notifDefType,
      hasHtmlMobile: this.hasHtmlMobile,
      helpHtmlId: this.helpHtmlId,
      publiContext: this.publiContext,
    }
    return JSON.stringify(json);
  }

  public fromAdminInfo (obj: AdminInfo): void {
    this.table = obj.table;
    this.objType = obj.objType;
    this.objName = obj.objName;
    this.category = obj.category;
    this.label = obj.label;
    this.count = obj.count;
    this.notifDefType = obj.notifDefType;
    this.hasHtmlMobile = obj.hasHtmlMobile;
    this.helpHtmlId = obj.helpHtmlId;
    this.publiContext = obj.publiContext;
  }

  public compareAdminInfo (value: AdminInfo): boolean {
    return (this.toJsonAdminInfo() == value.toJsonAdminInfo());
  }

  public cloneAdminInfo (): AdminInfo {
    return AdminInfo.fromJson(this);
  }

  // eslint-disable-next-line
  public static getDate(adminInfos: AdminInfo[]) {
  }
}
